import ApplicationAdapter from 'lumen/adapters/application';

export default class MarketPerformanceDataStatusAdapter extends ApplicationAdapter {
  buildURL(): string {
    return `${this.host}/apigateway/v1/app/bi/data-statuses`;
  }
}
